import { Link } from "gatsby";
import React from "react";
import { navigate } from "../../../utils/navigate";
import { slug } from "../../../utils/slug";

const HomeButton = ({ button, white = false }) => {
  if (button.linkType === "sectionId") {
    return (
      <button
        onClick={() => navigate(button.sectionId)}
        className={`px-6 h-10 text-sm md:text-base py-1 flex items-center justify-center leading-none relative uppercase w-max rounded-lg ${
          white
            ? "bg-logo1 hover:bg-[#EFEFEF] text-black"
            : "bg-white text-obsidian"
        }`}
      >
        <span style={{ letterSpacing: "0.1em" }} className="font-light">
          {button.buttonText}
        </span>
      </button>
    );
  } else if (button.linkType === "slug") {
    return (
      <Link
        className={`px-6 h-10 text-sm md:text-base py-1 flex items-center justify-center leading-none relative uppercase w-max rounded-lg ${
          white
            ? "bg-logo1 hover:bg-[#EFEFEF] text-black"
            : "bg-white text-obsidian"
        }`}
        to={slug(button.slug.current)}
      >
        <span style={{ letterSpacing: "0.1em" }} className="font-light">
          {button.buttonText}
        </span>
      </Link>
    );
  } else if (button.linkType === "url") {
    return (
      <a
        className={`px-6 h-10 text-sm md:text-base py-1 flex items-center justify-center leading-none relative uppercase w-max rounded-lg ${
          white
            ? "bg-logo1 hover:bg-[#EFEFEF] text-black"
            : "bg-white text-obsidian"
        }`}
        href={button.url}
        target="_blank"
      >
        <span
          style={{ letterSpacing: "0.1em", paddingTop: "0.4em" }}
          className="font-light"
        >
          {button.buttonText}
        </span>
      </a>
    );
  } else if (button.linkType === "appointmentPopup") {
    return (
      <button
        className={`px-6 h-10 text-sm md:text-base py-1 flex items-center justify-center leading-none relative uppercase w-max rounded-lg ${
          white
            ? "bg-white md:bg-black text-black md:text-white"
            : "bg-white text-obsidian"
        }`}
      >
        <span style={{ letterSpacing: "0.1em" }} className="font-light">
          {button.buttonText}
        </span>
      </button>
    );
  }
};

export default HomeButton;
